import { render, staticRenderFns } from "./WebAps.vue?vue&type=template&id=6654bcb0&"
import script from "./WebAps.vue?vue&type=script&lang=js&"
export * from "./WebAps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WebAps.vue"
export default component.exports